module.exports = __webpack_public_path__ + "static/kyaariTextLogoRed-1306f42e5c4056b4d62cdc277110048f.svg";